// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProfileIcon[data-v-2899f547]{height:1.8em;width:1.8em;min-width:1.8em;display:inline-grid;place-items:center;border:2px solid;border-radius:50%}.ProfileIcon i[data-v-2899f547]{font-size:.9em}\n", ""]);
// Exports
module.exports = exports;
